<div class="row" *ngIf="!(isSDK | async)">
  <div class="col mb-3">
    <h1 *ngIf="activeOrg">
      {{
        'Welcome, %organizationName%'
          | translate: { organizationName: activeOrg.name }
      }}
    </h1>
  </div>
</div>

<app-head></app-head>

<div class="row">
  <div
    class="col-12 col-xl-3 order-xl-2"
    *ngIf="
      totalStats?.totalOverdue.length !== 0 ||
      totalStats?.totalDueThisMonth.length !== 0 ||
      totalStats?.totalDue.length !== 0 ||
      totalStats?.totalPaymentsThisMonth.length !== 0
    "
  >
    <div class="row">
      <!-- Outgoing -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-12 mb-5">
        <div class="card">
          <div class="card-header px-3 px-md-4">
            <h4 class="card-header-title">
              {{ 'dashboard.stats.outgoing.title' | translate }}
            </h4>
          </div>
          <div class="card-body py-0 px-3 px-md-4">
            <div class="list-group list-group-flush">
              <!-- Overdue -->
              <app-total-stat
                *ngIf="totalStats?.totalOverdue.length"
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.outgoing.overdue.title' | translate
                }}"
                [data]="totalStats?.totalOverdue || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.outgoing.overdue.tooltip' | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/o/invoice'], {
                    paidInFull: false,
                    dateDue: { lt: today },
                    canceled: false,
                    draft: false
                  })
                "
              ></app-total-stat>

              <!-- Due this month -->
              <app-total-stat
                *ngIf="totalStats?.totalDueThisMonth.length"
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.outgoing.due-this-month.title' | translate
                }}"
                [data]="totalStats?.totalDueThisMonth || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.outgoing.due-this-month.tooltip' | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/o/invoice'], {
                    paidInFull: false,
                    dateDue: { between: [thisMonth.first, thisMonth.last] },
                    canceled: false,
                    draft: false
                  })
                "
              ></app-total-stat>

              <!-- (gross) total owed -->
              <app-total-stat
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.outgoing.total-owed.title' | translate
                }}"
                [data]="totalStats?.totalDue || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.outgoing.total-owed.tooltip' | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/o/invoice'], {
                    paidInFull: false,
                    canceled: false,
                    draft: false
                  })
                "
              ></app-total-stat>

              <!-- This month (net) total -->
              <app-total-stat
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  (activeOrg.taxSubject
                    ? 'dashboard.stats.outgoing.total-this-month.net.title'
                    : 'dashboard.stats.outgoing.total-this-month.gross.title'
                  ) | translate
                }}"
                [data]="totalStats?.totalThisMonth || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  (activeOrg.taxSubject
                    ? 'dashboard.stats.outgoing.total-this-month.net.tooltip'
                    : 'dashboard.stats.outgoing.total-this-month.gross.tooltip'
                  ) | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/o/invoice'], {
                    draft: false,
                    date: { between: [thisMonth.first, thisMonth.last] }
                  })
                "
              ></app-total-stat>

              <!-- Payments this month -->
              <app-total-stat
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.outgoing.payments-this-month.title'
                    | translate
                }}"
                [data]="totalStats?.totalPaymentsThisMonth || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.outgoing.payments-this-month.tooltip'
                    | translate
                }}"
                [routerLink]="
                  createLink(['../../payments'], {
                    date: { between: [thisMonth.first, thisMonth.last] }
                  })
                "
              ></app-total-stat>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Active outgoing documents -->
  <div class="col mb-5">
    <app-active-documents
      title="{{ 'documents.active.outgoing.title' | translate }}"
      cta="{{ 'Create new invoice' | translate }}"
    ></app-active-documents>
  </div>

  <app-welcome-message
    *ngIf="!hasAnyDocuments"
    class="col-12 col-lg-4"
  ></app-welcome-message>
</div>

<div class="row" *ngIf="!WL.getI('dashboard.active-documents.incoming.hidden')">
  <div
    class="col-12 col-xl-3 order-xl-2"
    *ngIf="
      totalStats?.incomingTotalOverdue.length !== 0 ||
      totalStats?.incomingTotalDueThisMonth.length !== 0 ||
      totalStats?.incomingTotalDue.length !== 0 ||
      totalStats?.incomingTotalPaymentsThisMonth.length !== 0
    "
  >
    <div class="row">
      <!-- Incoming -->
      <div class="col-12 col-sm-6 col-lg-4 col-xl-12 mb-5">
        <div class="card">
          <div class="card-header px-3 px-md-4">
            <h4 class="card-header-title">
              {{ 'dashboard.stats.incoming.title' | translate }}
            </h4>
          </div>
          <div class="card-body py-0 px-3 px-md-4">
            <div class="list-group list-group-flush">
              <!-- Overdue -->
              <app-total-stat
                *ngIf="totalStats?.incomingTotalOverdue.length"
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.incoming.overdue.title' | translate
                }}"
                [data]="totalStats?.incomingTotalOverdue || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.incoming.overdue.tooltip' | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/i/invoice'], {
                    paidInFull: false,
                    dateDue: { lt: today },
                    canceled: false,
                    draft: false
                  })
                "
              ></app-total-stat>

              <!-- Due this month -->
              <app-total-stat
                *ngIf="totalStats?.incomingTotalDueThisMonth?.length"
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.incoming.due-this-month.title' | translate
                }}"
                [data]="totalStats?.incomingTotalDueThisMonth || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.incoming.due-this-month.tooltip' | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/i/invoice'], {
                    paidInFull: false,
                    dateDue: { between: [thisMonth.first, thisMonth.last] },
                    canceled: false,
                    draft: false
                  })
                "
              ></app-total-stat>

              <!-- (gross) total owed -->
              <app-total-stat
                *ngIf="totalStats?.incomingTotalDue.length"
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.incoming.total-owed.title' | translate
                }}"
                [data]="totalStats?.incomingTotalDue || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.incoming.total-owed.tooltip' | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/i/invoice'], {
                    paidInFull: false,
                    canceled: false,
                    draft: false
                  })
                "
              ></app-total-stat>

              <!-- This month (net) total -->
              <app-total-stat
                *ngIf="totalStats?.incomingTotalThisMonth.length"
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  (activeOrg.taxSubject
                    ? 'dashboard.stats.incoming.total-this-month.net.title'
                    : 'dashboard.stats.incoming.total-this-month.gross.title'
                  ) | translate
                }}"
                [data]="totalStats?.incomingTotalThisMonth || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  (activeOrg.taxSubject
                    ? 'dashboard.stats.incoming.total-this-month.net.tooltip'
                    : 'dashboard.stats.incoming.total-this-month.gross.tooltip'
                  ) | translate
                }}"
                [routerLink]="
                  createLink(['../../documents/i/invoice'], {
                    draft: false,
                    date: { between: [thisMonth.first, thisMonth.last] }
                  })
                "
              ></app-total-stat>

              <!-- Payments this month -->
              <app-total-stat
                *ngIf="totalStats?.incomingTotalPaymentsThisMonth.length"
                class="list-group-item cursor-pointer"
                [class.is-loading]="loading.stats"
                title="{{
                  'dashboard.stats.incoming.payments-this-month.title'
                    | translate
                }}"
                [data]="totalStats?.incomingTotalPaymentsThisMonth || []"
                [locale]="activeOrg.locale"
                [defaultCurrency]="defaultCurrency"
                tooltipText="{{
                  'dashboard.stats.incoming.payments-this-month.tooltip'
                    | translate
                }}"
                [routerLink]="
                  createLink(['../../payments'], {
                    date: { between: [thisMonth.first, thisMonth.last] }
                  })
                "
              ></app-total-stat>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Active incoming documents -->
  <div class="col">
    <app-active-documents
      [incoming]="true"
      title="{{ 'documents.active.incoming.title' | translate }}"
      cta="{{ 'Add new expense' | translate }}"
    ></app-active-documents>
  </div>
</div>

<div class="row mb-5"></div>

<div class="row"
  *ngIf="!WL.getI('dashboard.graph.hidden')"
>
  <div class="col-12">
    <div class="card mb-3">
      <div class="card-header px-3 px-md-4">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="card-header-title">
              {{ 'Activity' | translate }}
            </h4>
          </div>
        </div>
      </div>

      <div class="card-body pb-0 px-3 px-md-4">
        <form name="chartForm" [formGroup]="chartForm">
          <div class="form-row">
            <div class="form-group col">
              <label for="type">{{ 'Type' | translate }}</label>
              <select
                class="form-control data-hj-whitelist"
                formControlName="type"
              >
                <option value="payments" *ngIf="!WL.getI('dashboard.graph.payments.hidden')">{{ 'Payments' | translate }}</option>
                <option value="invoice">
                  {{ 'Issued invoices' | translate }}
                </option>
                <option value="invoice-inc" *ngIf="!WL.getI('dashboard.graph.invoice/i.hidden')">
                  {{ 'Received invoices' | translate }}
                </option>
                <option value="estimate" *ngIf="!WL.getI('dashboard.graph.estimate.hidden')">
                  {{ 'Issued estimates' | translate }}
                </option>
                <option value="advance" *ngIf="!WL.getI('dashboard.graph.advance.hidden')">
                  {{ 'Issued advances' | translate }}
                </option>
                <option value="invoice-net" *ngIf="activeOrg.taxSubject">
                  {{ 'Issued invoices' | translate }}
                  {{ '( Net )' | translate }}
                </option>
                <option value="estimate-net" *ngIf="activeOrg.taxSubject && !WL.getI('dashboard.graph.estimate.hidden')">
                  {{ 'Issued estimates' | translate }}
                  {{ '( Net )' | translate }}
                </option>
                <option value="advance-net" *ngIf="activeOrg.taxSubject && !WL.getI('dashboard.graph.advance.hidden')">
                  {{ 'Issued advances' | translate }}
                  {{ '( Net )' | translate }}
                </option>
              </select>
            </div>

            <div class="form-group col">
              <label for="period">{{ 'Period' | translate }}</label>
              <select
                class="form-control data-hj-whitelist"
                (change)="onChangePeriod()"
                formControlName="period"
              >
                <option value="today">{{ 'Today' | translate }}</option>
                <option value="yesterday">{{ 'Yesterday' | translate }}</option>
                <option value="week-to-date">
                  {{ 'Week to date' | translate }}
                </option>
                <option value="previous-week">
                  {{ 'Last week' | translate }}
                </option>
                <option value="this-month">
                  {{ 'This month' | translate }}
                </option>
                <option value="month-to-date">
                  {{ 'Month to date' | translate }}
                </option>
                <option value="previous-month">
                  {{ 'Last month' | translate }}
                </option>
                <option value="half-year-to-date">
                  {{ '6 months to date' | translate }}
                </option>
                <option value="this-year">{{ 'This year' | translate }}</option>
                <option value="year-to-date">
                  {{ 'Year to date' | translate }}
                </option>
                <option value="previous-year">
                  {{ 'Last year' | translate }}
                </option>
                <option value="custom">{{ 'Manual' | translate }}</option>
              </select>
            </div>

            <div class="w-100 d-block d-md-none"></div>

            <div class="form-group col">
              <label for="from">{{ 'From' | translate }}</label>
              <div class="input-group">
                <input
                  class="form-control data-hj-whitelist"
                  readonly
                  name="from"
                  formControlName="from"
                  ngbDatepicker
                  #d="ngbDatepicker"
                  placement="bottom-left"
                  (dateSelect)="onChangeStartDate($event)"
                  [maxDate]="maxDate"
                  [markDisabled]="disableDay"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-light input-group-text"
                    (click)="d.toggle()"
                    type="button"
                  >
                    <i class="fe fe-sm fe-calendar"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="form-group col">
              <label for="to">{{ 'To' | translate }}</label>
              <div class="input-group">
                <input
                  class="form-control data-hj-whitelist"
                  readonly
                  name="to"
                  formControlName="to"
                  ngbDatepicker
                  #d2="ngbDatepicker"
                  placement="bottom-right"
                  (dateSelect)="onChangeEndDate($event)"
                  [maxDate]="maxDate"
                  [markDisabled]="disableDay"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-light input-group-text"
                    (click)="d2.toggle()"
                    type="button"
                  >
                    <i class="fe fe-sm fe-calendar"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="w-100 d-block d-md-none"></div>

            <div class="form-group col">
              <label for="dist">{{ 'Distribution' | translate }}</label>
              <select
                class="form-control data-hj-whitelist"
                formControlName="dist"
              >
                <option value="day">{{ 'Daily' | translate }}</option>
                <option value="week">{{ 'Weekly' | translate }}</option>
                <option value="month">{{ 'Monthly' | translate }}</option>
                <option value="year">{{ 'Yearly' | translate }}</option>
              </select>
            </div>

            <div class="form-group col col-sm-auto text-right">
              <label for="" class="d-block">&nbsp;</label>
              <button
                type="button"
                name="button"
                class="btn btn-outline-primary"
                (click)="getStats(activeOrg.id, chartForm.pristine)"
              >
                <span [hidden]="loading.chart">{{
                  'Update chart' | translate
                }}</span>
                <span class="ng-hide" [hidden]="!loading.chart"
                  >&nbsp;&nbsp;
                  <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
                  >&nbsp;&nbsp;
                </span>
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="px-1 is-loading-lg" [class.is-loading]="loading.chart">
        <div class="chart-wrapper" *ngIf="periodTotal.length">
          <ngx-charts-bar-vertical-stacked
            [results]="chartData"
            [scheme]="chartOptions.colorScheme"
            [customColors]="customColors"
            [animations]="false"
            [xAxis]="chartOptions.showXAxis"
            [yAxis]="chartOptions.showYAxis"
          >
          </ngx-charts-bar-vertical-stacked>
        </div>

        <div
          *ngIf="!loading.chart && !periodTotal.length"
          class="mt-5 text-center"
        >
          <i class="fad fa-feather-alt fa-3x text-muted mb-4"></i>
          <h3 class="text-muted font-weight-light">
            <span>{{ 'No data for selected range' | translate }}</span>
          </h3>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col"></div>
          <div class="col-auto">
            <div class="row">
              <div class="col-auto">
                <b class="text-muted" *ngIf="periodTotal && periodTotal.length"
                  >{{ 'Total in period' | translate }}:
                </b>
              </div>
              <div class="col-auto">
                <span *ngFor="let total of periodTotal">
                  <strong class="d-block">{{
                    total.total | pepCurrency: total.currency:activeOrg.locale
                  }}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
